import {Component, Input} from '@angular/core';

@Component({
  selector: 'sb-info-text',
  templateUrl: './sb-info-text.component.html',
  styleUrls: ['./sb-info-text.component.scss'],
  standalone: false,
})
export class SbInfoTextComponent {
  @Input() reverse: boolean;
}
